export default __webpack_public_path__ + "static/media/cloud-right.94664381.svg";